export default __webpack_public_path__ + "static/media/Animals08.e288e49c.jpg";